<template>
  <div class="wrapper">
    <header-component></header-component>
    <shop-cart-component></shop-cart-component>
    <router-view></router-view>
    <footer-component></footer-component>
    <login-modal-component></login-modal-component>
    <registration-modal-component></registration-modal-component>
    <checkout-modal-component></checkout-modal-component>
  </div>
</template>

<script>
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import LoginModal from "./components/modal/Login";
import RegistrationModal from "./components/modal/Registration";
import CheckoutModal from "./components/modal/Checkout";
import ShopCart from "./components/shopcart";

export default {
  name: "app",
  components: {
    "header-component": Header,
    "footer-component": Footer,
    "login-modal-component": LoginModal,
    "registration-modal-component": RegistrationModal,
    "checkout-modal-component": CheckoutModal,
    "shop-cart-component": ShopCart,
  },

  watch: {
    // $route: {
    //   handler: (to, from) => {
    //     console.log(to.meta.title)
    //     document.title = to.meta.title || "Your Website";
    //   },
    //   immediate: true,
    // },
  },
};
</script>
<!-- <style lang="scss" src="./global-style.scss"></style> -->


